import Delete from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";
import { ReactNode, useState } from "react";

import { ConfirmDialog } from "./ConfirmDialog";

type DeleteWithConfirmationProps = {
  tooltip: string;
  msg: string | ReactNode;
  resourceType?: string;
  resourceName?: string;
  header: string;
  loading: boolean;
  onConfirm?: () => void;
};

export function DeleteWithConfirmation({
  tooltip,
  header = "Are you sure you want to delete?",
  resourceName,
  resourceType,
  msg,
  loading,
  onConfirm,
}: DeleteWithConfirmationProps) {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title={tooltip}>
        <Delete fontSize="medium" onClick={() => setOpen(true)} />
      </Tooltip>
      <ConfirmDialog
        open={open}
        header={header}
        resources={[{ resourceName, resourceType }]}
        info={msg}
        loading={loading}
        onClose={onClose}
        onConfirm={async () => {
          if (typeof onConfirm === "function") {
            await onConfirm();
          }
          onClose();
        }}
      />
    </>
  );
}
